import { upload } from "@testing-library/user-event/dist/upload";

const getBaseUrl = () => {
  const { hostname, protocol } = window.location;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1' ) {
    return 'http://localhost:8000/api/v1/';
  } else if(hostname === 'ec2-16-144-235-186.us-west-2.compute.amazonaws.com') {
    return 'http://ec2-16-144-235-186.us-west-2.compute.amazonaws.com:8000/api/v1/';
  } else if (hostname === '16.144.235.186'){
    return 'http://16.144.235.186:8000/api/v1/';
  } else if (hostname === '159.195.64.22') {
    return 'http://159.195.64.22:8000/api/v1/';
  } 
  // else if (hostname === 'app.leadcaptive.com') {
  //   return 'https://app.leadcaptive.com:8000/api/v1/';
  // }
  // Staging / Production (same domain as frontend)
  return `${protocol}//${hostname}/api/v1/`;
};

export const API_CONFIG = {
  // Always use the direct URL to the backend
  
  BASE_URL: getBaseUrl(),
  ENDPOINTS: {
    REFRESH_TOKEN: 'auth/token/refresh',
    LOGIN: 'auth/login',
    LOGOUT: 'auth/logout',
    REGISTER: 'auth/register',
    DECODE_INVITE: 'auth/decode-invite/',
    FORGOT_PASSWORD: 'auth/forgot-password',
    VERIFY_OTP: 'auth/verify-otp',
    RESET_PASSWORD: 'auth/reset-password',
    UPLOAD_CAMPAIGN: 'campaign/upload',
    CAMPAIGN_LIST: 'campaign/list',
    STRATEGY: 'campaign/strategy',
    SEQUENCE: 'campaign/sequence',
    UPDATE_EMAIL_TEMPLATE: 'campaign/sequence/template',
    CAMPAIGN_DETAIL: 'campaign/details',
    CAMPAIGN_PROGRESS_STREAM: 'campaign',
    LAUNCH_SEQUENCE: 'campaign/sequence/schedule',
    SALESFORCE_ACCOUNTS: 'campaign/sequence/salesforce-accounts',
    RETRY_LEAD_SCRAPE: 'campaign/lead',
    RETRY_EMAIL_VERIFICATION: 'campaign/email-verification',
    UPDATE_SEQUENCE_SENDER: 'campaign/sequence',
    RESELECT_SALESFORCE_ACCOUNT: 'campaign/sequence',
    RESCHEDULE_SEQUENCE: 'campaign/sequence',
    ADSPOWER_GET_ALL: 'ap_user/',
    ADSPOWER_UPDATE: 'ap_user',
    ADSPOWER_CREATE: 'ap_user/',
    ADSPOWER_GET_SINGLE: 'ap_user/',
    ADSPOWER_DELETE: 'ap_user',
    DASHBOARD: 'campaign/dashboard',
    WS_EMAIL_UPDATE: 'ws/',
    ADMIN_USERS: 'auth/users',
    LOGS_SEARCH: 'logs/search',
    LOGS_DOMAIN: 'logs/domain',
    LOGS_USER: 'logs/user',
    LOGS_CAMPAIGN: 'logs/campaign',
    TEST_SEND_CAMPAIGN: 'campaign/sequence/test-send',
    SALESFORCE_SEND_METHOD: 'salesforce-api/send-method',
    SALESFORCE_API_SENDER_EMAIL: 'salesforce-api/sender-email',
    SALESFORCE_API_SENDER_EMAIL_STATUS: 'salesforce-api/sender-email/status',
  },
};